module.exports = __webpack_public_path__ + "static/media/lumiere_education_logo.1cdd9f10.jpeg";